"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useTextCount;
var _react = require("react");
var _FormControlContext = require("./FormControlContext");
function useTextCount() {
  var _useContext = (0, _react.useContext)(_FormControlContext.FormControlContext),
    textCount = _useContext.textCount;
  return textCount;
}